module.exports = __webpack_public_path__ + "img/round.fbb75d27.svg";